require('bootstrap')
require('eonasdan-bootstrap-datetimepicker')